var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3H11.5V13H3.5V3ZM21.5001 3H13.5001V9H21.5001V3ZM9.49986 11V4.99996H5.49986V11H9.49986ZM19.5 6.99996V4.99996H15.5V6.99996H19.5ZM19.5 13V19H15.5V13H19.5ZM9.49986 19V17H5.49986V19H9.49986ZM21.5001 11H13.5001V21H21.5001V11ZM3.5 15H11.5V21H3.5V15Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMobileIcon);
export default __webpack_public_path__ + "static/media/dashboard-mobile-icon.b67fceca8975ec3e8deaf2ba233cb14d.svg";
export { ForwardRef as ReactComponent };